import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CurrencyUtils from '../../utils/CurrencyUtils';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import PayrollService from '../../services/PayrollService';
import DateUtils from '../../utils/DateUtils';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import ActionLink from '../../components/ActionLink';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class UserPayrollListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new PayrollService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statuses: [],
        };
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            status: criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            dateFrom: null,
            dateTo: null,
            status: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('PayrollStatus')
            .then((statuses) => {
                this.setState({
                    statuses,
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    afterRowSelected(e) {
        console.log(e.type);
    }

    getDataKey() {
        return 'email';
    }
    getListTitle() {
        return 'user-payroll.listTitle';
    }
    getCriteriaName() {
        return 'user-payroll-list-sc';
    }

    getContainerListName() {
        return 'user-payroll-list-container';
    }
    moneyTemplate(rowData) {
        return CurrencyUtils.currency(rowData.limit);
    }
    moneyTotalTemplate(rowData) {
        return CurrencyUtils.currency(rowData.totalAmount);
    }
    statusTemplate(rowData) {
        return rowData.status ? t(`PayrollStatus.${rowData.status}`) : '';
    }
    booleanTemplate(rowData) {
        return rowData.debitOverLimit ? t('global.true') : t('global.false');
    }
    dateStartTemplate(rowData) {
        return DateUtils.formatDate(rowData.dateStart);
    }
    dateEndTemplate(rowData) {
        return DateUtils.formatDate(rowData.dateEnd);
    }

    prepareColumns() {
        return [
            {field: 'dateStart', header: t('payroll.list.dateStart'), body: this.dateStartTemplate},
            {field: 'dateEnd', header: t('payroll.list.endDate'), body: this.dateEndTemplate},
            {
                field: 'limit',
                header: t('payroll.list.pay-limit'),
                float: 'right',
                body: this.moneyTemplate,
            },
            {
                field: 'debitOverLimit',
                header: t('payroll.list.zero-over-limit'),
                body: this.booleanTemplate,
            },
            {
                field: 'status',
                header: t('payroll.list.status'),
                float: 'right',
                body: this.statusTemplate,
            },
            {
                field: 'totalAmount',
                header: t('payroll.list.total-amount'),
                float: 'right',
                body: this.moneyTotalTemplate,
            },
            {
                field: 'createdByEmail',
                header: t('payroll.list.created-by'),
                float: 'right',
            },
            {field: '', float: 'center', header: t('global.action'), sortable: false, body: this.actionTemplate, width: '90px'},
        ];
    }


actionTemplate(rowData) {
    const menuRef = React.createRef();
    const { detailUrl } = this.props;
    const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');

    const menuItems = [
        {
            label: t('global.details'),
            icon: 'pi pi-eye',
            command: () => this.handleGoToDetail(detailHref),
        },
        rowData.status === 'APPROVED' && {
            label: t('payroll.list.export'),
            icon: 'pi pi-file-excel',
            command: () => {
                this.service.export(rowData.id, t('payroll.list.name'), 'xlsx').catch(() => {
                    this.showErrorMessage(t('global.generate-error'));
                });
            },
        },
    ].filter(Boolean); // Usuwa `false` wartości, jeśli warunek nie jest spełniony

    return (
        <div>
            <Menu model={menuItems} popup ref={menuRef} />
            <Button
                icon="pi pi-ellipsis-v"
                className="menu-items"
                onClick={(event) => menuRef.current.toggle(event)}
            />
        </div>
    );
}

    breadCrumbItems() {
        return [{name: t('userPayroll.listName'), url: '/user-payroll-list'}];
    }

    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaCalendarRangeComponent
                        id='date-sc'
                        idFrom='dateFrom-sc'
                        idTo='dateTo-sc'
                        name='date'
                        nameFrom='dateFrom'
                        nameTo='dateTo'
                        label={t('payroll.list.criteria.date')}
                        colClass='col-xl-6 col-lg-12 col-sm-12'
                        from={this.state.criteria.dateFrom}
                        to={this.state.criteria.dateTo}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        refreshFromBackend
                        showButtonBar
                        sharedLabel
                        renderDash
                        maxDateInfinite
                        placeholderFrom={'Data od'}
                        placeholderTo={'Data do'}
                        inputsClassName='col-6'
                    />
                    <CriteriaDropdownComponent
                        id='status'
                        name='status'
                        showClear
                        label={t('payroll.list.criteria.status')}
                        value={this.state.criteria.status}
                        options={this.state.statuses}
                        placeholder={t('setting.all')}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        filter
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        return [];
    }

    footerGroup() {}

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    handleClosePayrollRequestDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({payrollDialogVisibile: false});
        if (callback) callback();
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

UserPayrollListContainer.defaultProps = {
    lazy: true,
    disablePointerFromList: true,
    detailUrl: '/user-payroll/details',
};

UserPayrollListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    disablePointerFromList: PropTypes.string,
};

export default withRouter(withTranslation()(UserPayrollListContainer));
